import { Select, Label, Row, Column, Panel, Spinner, TextInput, Icon } from '../../components'
import { useContext, useEffect, useState, useRef } from 'react'
import { SelectOption } from '../../shared/components/input/SelectOption'
import '../customer.css'
import { getPolicyStatusList, getStateCodeList } from '../hooks/useLookUpOptions'
import CustomerFilterRequest from '../model/CustomerFilterRequest'
import { QuickSearchContext } from '../../customer/customer'
import { showGridContext } from '../filter/CustomerFilter'
import { ErrorBoundary } from 'react-error-boundary'
import _ from 'lodash'
import Logger from '../../shared/services/Logger'
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import * as constant from '../../shared/util/constant'
import * as label from '../../shared/util/label'
import CustomerStandardSearchService from './CustomerStandardSearchService'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form';
import { AbilityContext } from '../../shared/abilities/AbilityContext'

import { Button } from 'primereact/button';
import { PrimeIcons } from 'primereact/api';
import { FloatLabel } from 'primereact/floatlabel'
import { InputText } from 'primereact/inputtext'
import { InputMask } from 'primereact/inputmask';
// @ts-ignore - react-datepicker is used across the app without bundled type declarations in this project.
import DatePicker from 'react-datepicker';
import { Col, FloatingLabel, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { REJECT_EMAIL_SEND_ERROR } from '../../DocuMate/shared/util/docuMateConstant'
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../shared/store";
import { updateLookupData } from "../customer-slice/Customer-lookup-slice";
import { clearCustomerSearchResults, setCustomerSearchResults } from "../customer-slice/Customer-search-result-slice";
//import handleTabKey from '../../shared/hooks/commonTabbing'



// const updateTitle = useUpdateTitle()
//   useEffect(() => {
//     updateTitle('Customer Filter')
//   })
// interface Props {
//   onSearching: (filterRequest: CustomerFilterRequest) => void,
//   onAllowingSearching: (isSearchingAllowed: boolean) => void
// }
// interface Props{
//   onSearch:Function
// }

interface Props {
  navigateTo?: (location: string) => void
  isAdvancedSearchFilter?: boolean
}

const CustomerStandardFilterForm = (props: Props) => {
  //const {onSearching, onAllowingSearching } = props

  //   const [state, setState] = useState({
  //   isPaneOpen: false,
  //   isPaneOpenLeft: false
  // });

  const custSearchService = new CustomerStandardSearchService();
  const saveButtonRef = useRef(null);
  const firstControlRef = useRef(null);
  const searchPropertyControlRef = useRef(null);
  const searchMailingControlRef = useRef(null);
  const clearButtonRef = useRef(null);
  const coapplicantSearchRef = useRef(null);
  const applicantSearchRef = useRef(null);
  const policyControlRef = useRef(null);

  const [collapse, SetisCollapse] = useState(true) // Address / Mail Search
  const [mailCollapse, SetMailCollapse] = useState(false)
  const [applicantSearch, SetApplicantSearch] = useState(false)
  const [coapplicantSearch, SetCoApplicantSearch] = useState(false)
  const [quickSearchStatus, SetquickSearchStatus] = useState(false)
  const [loading, setLoading] = useState(false);

  const initalFilterState: CustomerFilterRequest = {
    firstName: '',
    lastName: '',
    eMail: '',
    homePhone: '',
    address1: '',
    address2: '',
    city: '',    
    zipCode: '',
    state: '',
    isPropertySearch: true,
    custNumber: null,
    policyNumber: '',
    PolicyTypeId: '',
    PolEffDate: null,
    CompanyId: '',
    WritingCompanyId: '',
    countryId : constant.DATA_IDs.COUNTRIES.USA,
    /* Uncommenting for now - enable back when advance serach is enabled.
    ApplicantOccupation: '',
    ApplicantSelfemployed: '',
    ApplicantDateofBirthFrom: null,
    ApplicantDateofBirthTo: null,
    CoApplicantFirstName: '',
    CoApplicantLastName: '',
    CoApplicantEmail : '',
    CoApplicantPhone: '',
    CoApplicantOccupation: '',
    CoApplicantSelfemployed: '',
    CoApplicantDateofBirthFrom: null,
    CoApplicantDateofBirthTo: null,
    LastDateSolicited:null,
    SolicitedCampaignsTimeframe:'',
    DaySinceLastSolicited:'',
    ByCampaigns:'',
    Unsubscribe:'',
    DoNotEmail:'',
    DoNotMail:'',
    EDD:'',
    SMSText:'',
    PropertyAppSuit:'',
    PropertyCity:'',
    PropertyCountry:'',
    PropertyState:'',
    PropertyZip:'',
    MailingStreetAddress:'',
    MailingAppSuit:'',
    MailingCity:'',
    MailingCountry:'',
    MailingState:'',
    MailingZip:'',
    RoofUpdateYearFrom:null,
    RoofUpdateYearTo:null,
    RoofType:'',
    RoofShape:'',
    RoofMaterial:'',
    ConstructionType:'',
    Pool:'',
    Trampoline:'',
    DogBreed:'',
    Carrier:'',
    WritingCompany:'',
    YearAsCustomer:'',
    Agency:'',
    PolicyType:'',
    PremiumFrom:'',
    PremiumTo:'',
    LoanNumber:'',
    NotationCode:'',
    CoverageARangeFrom:'',
    CoverangeARangeTo:'',
    YearBuiltRangeFrom:'',
    YearBuiltRangeTo:'',
    IntialPolicyEffectiveDateFrom:null,
    InitialPolicyEffectiveDateTo:null,
    CurrentPolicyEffectiveDateFrom:null,
    CurrentPolicyEffectiveDateTo:null,
    PolicyStatus:'',
    LastNoteEnteredBy:'',
    AllPerilDeductiblesFrom:null,
    AllPerilDeductibleTo:null,
    WindHailDeductiblesFrom:null,
    WindHailDeductiblesTo:null,
    HurricaneDeductiblesFrom:null,
    HurricaneDeductiblesTo:null,
    DwellingCoverageFrom:null,
    DwellingCoverageTo:null,
    PolicyNumber:'',
    AMSNumber:'',
    IsApplicantSearch:applicantSearch,
    IsCoApplicantSearch:coapplicantSearch,
    IsPropertySearch:collapse,
    IsMailingSearch:mailCollapse,
    IsQuickSearch:quickSearchStatus,
    QuickSearchString:''
    */
  }


  const [isSearchingAllowed, setIsSearchingAllowed] = useState(false);
  
  const filterContext: any = useContext(showGridContext as any);
  const { GridVisibility, InputFilter, searchResultData } = filterContext;
  const [showGrid, setShowGrid] = GridVisibility
  const [searchFilter, setInputFilter] = InputFilter
  const { searchResult, setsearchResult } = searchResultData

  const [filter, setSearchFilter] = useState<CustomerFilterRequest>(() => {
    const saved = localStorage.getItem(constant.CUSTOMER_FILTER_STORAGE_KEY);
    return saved ? { ...initalFilterState, ...JSON.parse(saved) } : initalFilterState;
  });
  const quickContext: any = useContext(QuickSearchContext as any);
  const { quickFilterData } = quickContext;
  //const[quickFilterContextData, setquickFilterContextData]=quickFilterData
  const [quickSearch, setQuickSearch] = useState(quickFilterData);
  const [keyEventCode, setKeyEventCode] = useState("");
  const isAdvancedSearchFilter = !!props.isAdvancedSearchFilter;
  const ability = useContext(AbilityContext);
  const canUserCreateCustomer = ability.can('create', "Customer", constant.ScreenName.CUSTOMER);
    const dispatch = useDispatch();
    let countryLookup = useSelector((state: RootState) => state?.LookupState.countryList);
    let stateLookup = useSelector((state: RootState) => state?.LookupState.stateUSList);
    let policyTypeLookup = useSelector((state: RootState) => state?.LookupState.policyTypeList);
    let companyLookup = useSelector((state: RootState) => state?.LookupState.companyList);
    let parentCompanyLookup = useSelector((state: RootState) => state?.LookupState.parentCompaniesList);
    let writingCompanyLookup = useSelector((state: RootState) => state?.LookupState.writingCompaniesList);
    const storedSearchResult = useSelector((state: RootState) => state.customerSearchResultSlice);

  const [countries, setCountries] = useState<SelectOption[]>([]);
  const [isStateAsDropdown, setIsstateAsDropdown] = useState(true);
  const [statesUS, setUSState] = useState<SelectOption[]>([]);
  const [statesCanada, setCanadaState] = useState<SelectOption[]>([]);
  const [states, setStates] = useState<SelectOption[]>([]);
  const [policyTypes, setPolicyTypes] = useState<SelectOption[]>([]);
  const [parentCompanies, setParentCompanies] = useState<SelectOption[]>([]);
  const [allWritingCompanies, setAllWritingCompanies] = useState<SelectOption[]>([]);
  const [filteredWritingCompanies, setFilteredWritingCompanies] = useState<SelectOption[]>([]);


  const initializeComponent = async () => {
          if (countryLookup.length === 0
            || stateLookup.length === 0
            || policyTypeLookup.length === 0
            || companyLookup.length === 0
            || (parentCompanyLookup || []).length === 0
            || (writingCompanyLookup || []).length === 0) {
              let { countryList, stateUSList, stateCanadaList, policyTypeList, companyList, parentCompanyList, writingCompanyList } = await custSearchService.fetchComponentInitData();
              dispatch(updateLookupData({ data: countryList, type: constant.SlicerLookUpConstant.COUNTRY }));
              dispatch(updateLookupData({ data: stateUSList, type: constant.SlicerLookUpConstant.US_STATE }));
              dispatch(updateLookupData({ data: stateCanadaList, type: constant.SlicerLookUpConstant.CANADA_STATE }));
              dispatch(updateLookupData({ data: policyTypeList, type: constant.SlicerLookUpConstant.POLICY_TYPE }));
              dispatch(updateLookupData({ data: companyList, type: constant.SlicerLookUpConstant.COMPANY_LIST }));
              dispatch(updateLookupData({ data: parentCompanyList, type: constant.SlicerLookUpConstant.PARENT_COMPANIES }));
              dispatch(updateLookupData({ data: writingCompanyList, type: constant.SlicerLookUpConstant.WRITING_COMPANIES }));
              setCountries([...countryList]);
              setUSState([...stateUSList]);
              setCanadaState([...stateCanadaList]);
              setStates([...stateUSList]);
              setPolicyTypes([...policyTypeList]);
              setParentCompanies([...parentCompanyList]);
              setAllWritingCompanies([...writingCompanyList]);
          }
          else {
              setCountries([...countryLookup]);
              setUSState([...stateLookup]);
              setStates([...stateLookup]);
              setCanadaState([...stateLookup]);
              setPolicyTypes([...policyTypeLookup]);
              setParentCompanies([...(parentCompanyLookup || [])]);
              setAllWritingCompanies([...(writingCompanyLookup || [])]);
            }
  }

  useEffect(() => {
    initializeComponent()
  }, []);


  //console.log("Standard Search"+ filter);
  useEffect(() => {
    if (custSearchService.IsFilterInputValid(filter)) {
      setIsSearchingAllowed(true);
      //setShowGrid(true)
    }
    else {
      //onAllowingSearching(false);
      setIsSearchingAllowed(false);
      // setShowGrid(false)

    }

  }, [filter]);



  const onSearch = async () => {
    /*
    //console.log('Standard Search')
    if(quickSearch!= null && quickSearch!=undefined)
    {
    filter.IsQuickSearch=quickSearch[0].IsQuickSearch;
    filter.QuickSearchString=quickSearch[0].QuickSearchString
    setQuickSearch(quickFilterData)
    SetquickSearchStatus(filter.IsQuickSearch)
    }
    */
    //setSearchFilter(filter);
    //setInputFilter(filter)

    // GridContex.GridVisibility=showGrid
    // GridContex.InputFilter=filter
    // SetGridContext(GridContex)

    try {
      setLoading(true);
      const filterWithFlag = { ...filter, isAdvancedSearch: props.isAdvancedSearchFilter === true };
      localStorage.setItem(constant.CUSTOMER_FILTER_STORAGE_KEY, JSON.stringify(filterWithFlag));
      let searchResp = await custSearchService.FetchCustomers(filterWithFlag);
      let customerSearchData = searchResp.data
      setsearchResult(customerSearchData);
      dispatch(setCustomerSearchResults(customerSearchData));

      if (searchResp.status == 206) {
        toast.warn(constant.CUSTOMER_STANDARD_SEARCH_PARTIAL_DATA, {
          position: toast.POSITION.TOP_RIGHT
        });
      }
    } catch (ex: any) {
      if (ex.status == 400 && ex.data.length > 0 && ex.data[0].errorMessage) {
        toast.warn(ex.data[0].errorMessage, {
          position: toast.POSITION.TOP_RIGHT
        });
      }
      else if (ex.status == 404) {
        toast.warn(constant.CUSTOMER_STANDARD_SEARCH_NO_RESULT_FOUND, {
          position: toast.POSITION.TOP_RIGHT
        });
      }
      else {
        toast.error(constant.CUSTOMER_STANDARD_SEARCH_ERROR_WHILE_SEARCHING, {
          position: toast.POSITION.TOP_RIGHT
        });
      }
      setsearchResult([]);
      dispatch(setCustomerSearchResults([]));
      Logger.logError(ex);
    } finally {
      setLoading(false);
    }
    //setShowGrid(true);
  }

  useEffect(() => {
    if (storedSearchResult.isLoaded) {
      setsearchResult(storedSearchResult.results);
    }
    else if (localStorage.getItem(constant.CUSTOMER_FILTER_STORAGE_KEY)) {
      // Redux is empty after refresh/tab close then call search api using filter already populated from localStorage
      onSearch();
    }

    // sync the checkbox UI state to match
    const restoredFilter = filter as any;
    if (restoredFilter.IsApplicantSearch) SetApplicantSearch(true);
    if (restoredFilter.IsCoApplicantSearch) SetCoApplicantSearch(true);
  }, []);

  useEffect(() => {
    if (quickFilterData != null && quickFilterData[0].QuickSearchString !== undefined && quickFilterData[0].QuickSearchString.length > 3 && quickFilterData[0].IsQuickSearch === true) {
      onSearch();
    }
  }, [quickFilterData]);

  useEffect(() => {
    if (filter.CompanyId && allWritingCompanies.length > 0) {
      setFilteredWritingCompanies(
        allWritingCompanies.filter(item => item.parentId === filter.CompanyId && item.parentId !== item.value)
      );
      return;
    }

    setFilteredWritingCompanies([]);
  }, [filter.CompanyId, allWritingCompanies]);

  const onFieldChange = (name: string, value: string | Date | boolean | null) => {
    setSearchFilter({
      ...filter,
      [name]: value,
    })
  }

  //const [PolicyOption, setPolicyOptions] = useState<SelectOption[]>([{ label: "", value: "" }]);

  const manageCollapse = () => {  
    setSearchFilter((prevState) => ({
      ...prevState,
      isPropertySearch: true,
      countryId: constant.DATA_IDs.COUNTRIES.USA as string,
    }));
   onCountrySelection(constant.DATA_IDs.COUNTRIES.USA)
  };
  
  const manageMailCollapse = () => {
    onFieldChange("isPropertySearch", false);
  };

  useEffect(() => {
    //
  }, [collapse])

  useEffect(() => {
    //
  }, [mailCollapse]);

  const setPropertySearch = () => {
    setSearchFilter({
      ...filter,
      isPropertySearch: true
    });
    SetisCollapse(true);
  };

  const setMailingSearch = () => {
    setSearchFilter({
      ...filter,
      isPropertySearch: false
    });
    SetisCollapse(true);
  };

  const manageApplicantSearch = (event) => {
    if (event.target.checked) {
      SetApplicantSearch(true)
      onFieldChange("IsApplicantSearch", event.target.checked)
    }
    else {
      SetApplicantSearch(false)
      onFieldChange("IsApplicantSearch", event.target.checked)

    }

  }


  const manageCoApplicantSearch = (event) => {
    if (event.target.checked) {
      SetCoApplicantSearch(true)
      onFieldChange("IsCoApplicantSearch", event.target.checked)
    }
    else {
      SetCoApplicantSearch(false)
      onFieldChange("IsCoApplicantSearch", event.target.checked)
    }

  }

  const onEnterClick = (event) => {
    if (isSearchingAllowed && event.target.id !== "btnStandardSearchClear" && event.key === 'Enter') {
      onSearch()
    }
  }

  useEffect(() => {
    window.addEventListener("keydown", onEnterClick);
    return () => {
      window.removeEventListener("keydown", onEnterClick);
    };

  }, [onEnterClick]);

  //#region Policy Status list
  //const [filter, setFilter] = useState<CustomerFilterRequest>(initalFilterState);
  const { data: policyStatus, isLoading: isLoadingPolicyStatus } = getPolicyStatusList();
  const [PolicyStatusOption, setPolicyStatusOptions] = useState<SelectOption[]>([{ label: "", value: "" }]);
  /* enable when policy base search is enabled.
   useEffect(() => {
     if (policyStatus === undefined || isLoadingPolicyStatus) {
  
       <Spinner type="DotLoader" loading />
     }
     else {
       setPolicyStatusOptions(policyStatus.map((data) => {
         return {
           value: data.PolicyStatusCode,
           label: data.PolicyStatusName
         }
       }
       )
       )
     }
  
   }, [policyStatus])
   */
  //#endregion Policy Status list
  const FallbackComponent = ({ error, resetErrorBoundary }: any) => {
    console.log("An error occurred:");
    console.log(error.message);
    return (
      <div>
        <h1>An error occurred: {error.message}</h1>
        <button onClick={resetErrorBoundary}>Try again</button>
      </div>
    );
  };

  const onClearFilters = () => {
    setSearchFilter(initalFilterState);
    SetApplicantSearch(false);
    SetCoApplicantSearch(false);
    setsearchResult([]);
    setFilteredWritingCompanies([]);
    localStorage.removeItem(constant.CUSTOMER_FILTER_STORAGE_KEY);
    dispatch(clearCustomerSearchResults());
  }

  const onAddNewCustomer = () => {
    props.navigateTo?.("/customer-new");
  }

  const onCountrySelection = (countrySelected: string) => {

    if (countrySelected == constant.DATA_IDs.COUNTRIES.USA || countrySelected == constant.DATA_IDs.COUNTRIES.CANADA) {
      setIsstateAsDropdown(true);
      setStates(countrySelected == constant.DATA_IDs.COUNTRIES.USA ? statesUS : statesCanada);
    }
    else {      
      setIsstateAsDropdown(false);
      setStates([]);
    }
  }

  const isCountryEffectInitialRun = useRef(true);
  useEffect(() => {
    // keep the state restored from localStorage; only reset when the user changes country
    if (isCountryEffectInitialRun.current) {
      isCountryEffectInitialRun.current = false;
      return;
    }
    setSearchFilter({
        ...filter,
        state: "",      
    }) 
  }, [filter.countryId]);

    const handlePaste = (event) => {
        event.preventDefault();
        let pastedText = event.clipboardData.getData("text");
        if (event.target.name == "homePhone") {
            pastedText = pastedText.replace(/\D/g, '');
            if (pastedText.length > 10 && Number(pastedText)) {
                pastedText = pastedText.slice(-10);
            }
            onFieldChange(event.target.name, pastedText);
        }
        else if (event.target.name == "custNumber") {
            pastedText = pastedText.replace(/\s+/g, "");
            if (Number(pastedText)) {
                onFieldChange('custNumber', pastedText)
            }
        }
    };

  return (
    <ErrorBoundary FallbackComponent={FallbackComponent}>
      <Container fluid>
        <Row className="" >

          <Column lg={7} md={7} className='border-end pe-3'>
            <Row className='mb-3'>
              <Column>
                <div tabIndex={0} className='d-flex justify-content-between align-items-center'>
                  <div className='d-flex align-items-center'>
                    <h6 className='poppins-bold me-3 mb-0'>Customer Search</h6>
                    <div className=''>
                        <Form.Check
                            id='SearchCustomer'
                            inline>
                            <Form.Check.Input
                             type="checkbox"
                             checked={true}
                             disabled={true}
                            />
                            <Form.Check.Label>
                             {label.StandardSearchLable.SEARCH_CUSTOMER}
                            </Form.Check.Label>
                        </Form.Check>
                    </div>
                    <div className=''>
                      <Form.Check
                        id='SearchApplicant'
                        inline>
                        <Form.Check.Input
                          type="checkbox"
                          checked={applicantSearch}
                          ref={applicantSearchRef}
                          onChange={manageApplicantSearch}
                          tabIndex={2}
                          onKeyDown={(e) => {
                            if (e.key == "Tab" && e.shiftKey) {
                                  e.preventDefault();
                            }
                          }}
                        />
                        <Form.Check.Label>
                          {label.StandardSearchLable.SEARCH_INSURED}
                        </Form.Check.Label>
                      </Form.Check>
                    </div>
                    <div className=''>
                      <Form.Check
                        id='SearchCoApplicant'
                        inline>
                        <Form.Check.Input
                          type="checkbox"
                          checked={coapplicantSearch}
                          ref={coapplicantSearchRef}
                          onChange={manageCoApplicantSearch}
                          tabIndex={3}
                          onKeyDown={(e) => {
                            if (e.key == "Tab" && e.shiftKey) {
                              applicantSearchRef.current.focus();
                              e.preventDefault();
                            }
                            if (e.key == "Tab" && !e.shiftKey) {
                              firstControlRef.current.focus();
                              e.preventDefault();
                            }
                          }}
                        />
                        <Form.Check.Label>
                          {label.StandardSearchLable.SEARCH_CO_INSURED}
                        </Form.Check.Label>
                      </Form.Check>
                    </div>
                  </div>
                  <div className='right ms-auto'>
                    <Button
                      tabIndex={1}
                      ref={firstControlRef}
                      onClick={onAddNewCustomer}
                      onKeyDown={(e) => {
                        if (e.key == "Tab" && e.shiftKey) {
                          coapplicantSearchRef.current.focus();
                          e.preventDefault();
                        }
                        if (e.key == "Tab") {
                          policyControlRef.current.focus();
                          e.preventDefault();
                        }
                      }}
                      size='small'
                      disabled={!canUserCreateCustomer}
                      >
                      <FontAwesomeIcon icon={'plus'} className='me-2'></FontAwesomeIcon>
                      Add New Customer
                    </Button>
                  </div>
                </div>
              </Column>
            </Row>
            <Row>
              <Column md={4} className='border-end pe-3'>
                <div className='mb-4'>
                  <FloatLabel>
                    <InputText
                      id="Policy"
                      value={filter.policyNumber}
                      onChange={(e) => onFieldChange('policyNumber', e.currentTarget.value)}
                      size={25}
                      autoFocus
                      tabIndex={4}
                      ref={policyControlRef}
                      onKeyDown={(e) => {
                        if (e.key == "Tab" && e.shiftKey) {
                          firstControlRef.current.focus();
                          e.preventDefault();
                        }
                      }}
                      placeholder={label.StandardSearchLable.POLICY_NUMBER}
                    />
                    <label htmlFor="Policy">{label.StandardSearchLable.POLICY_NUMBER}</label>
                  </FloatLabel>
                </div>
                <div className='mb-0'>
                  <FloatLabel>
                    <InputText
                      id="custNumber"
                      name="custNumber"
                      keyfilter="int"
                      value={filter.custNumber?.toString() || ''}
                      onChange={(e) => onFieldChange('custNumber', e.currentTarget.value)}
                      maxLength={25}
                                          tabIndex={5}
                                          onPaste={handlePaste}
                      placeholder={label.StandardSearchLable.ACCOUNT}
                    />
                    <label htmlFor="custNumber">
                      {label.StandardSearchLable.ACCOUNT}
                    </label>
                  </FloatLabel>
                </div>
                {isAdvancedSearchFilter && (
                  <div className='mt-4 mb-0'>
                    <Select
                      id="policyType"
                      controlId="policyType"
                      label="Policy Type"
                      options={policyTypes}
                      //disabled = {true}
                      defaultSelected={policyTypes.filter(option => option.value === filter.PolicyTypeId)}
                      onChange={(values) => onFieldChange('PolicyTypeId', (values[0] as string) || null)}
                      tabIndex={6}
                      className='mb-0'
                      placeholder="Select Policy Type"
                      multiple={false}
                    />
                  </div>
                )}
                {isAdvancedSearchFilter && (
                  <div className='mt-4 mb-0'>
                    <Select
                      id="parentCompany"
                      controlId="parentCompany"
                      label="Parent Company"
                      options={parentCompanies}
                      defaultSelected={parentCompanies.filter(option => option.value === filter.CompanyId)}
                      onChange={(values) => {
                        const selectedParent = (values[0] as string) || '';
                        setSearchFilter(prev => ({
                          ...prev,
                          CompanyId: selectedParent,
                          WritingCompanyId: '',
                        }));
                      }}
                      tabIndex={10}
                      className='mb-0'
                      placeholder="Select Parent Company"
                      multiple={false}
                    />
                  </div>
                )}
              </Column>
              <Column md={8} className='ps-3'>
                <Row>
                  <Column md={6}>
                    <div className='mb-4'>
                      <FloatLabel>
                        <InputText
                          id="FirstName"
                          value={filter.firstName}
                          onChange={(e) => onFieldChange('firstName', e.currentTarget.value)}
                          size={25}
                          tabIndex={6}
                          placeholder={label.StandardSearchLable.FIRST_NAME}
                        />
                        <label htmlFor="Policy">{label.StandardSearchLable.FIRST_NAME}</label>
                      </FloatLabel>
                    </div>

                    <div className='mb-0'>
                      <FloatLabel>
                        <InputText
                          id="LastName"
                          value={filter.lastName}
                          onChange={(e) => onFieldChange('lastName', e.currentTarget.value)}
                          size={25}
                          tabIndex={7}
                          placeholder={label.StandardSearchLable.LAST_NAME}
                        />
                        <label htmlFor="LastName">{label.StandardSearchLable.LAST_NAME}</label>
                      </FloatLabel>
                    </div>
                  </Column>
                  <Column md={6}>
                    <div className='mb-4'>
                      <div className="input-group has-validation mb-3">
                        <span className="input-group-text remove-right-radius">
                          <Icon icon="email" className="text-muted fa-fw" />
                        </span>
                        <FloatingLabel
                          controlId="mobile"
                          label={label.StandardSearchLable.EMAIL}
                        >
                          <Form.Control
                            type="email"
                            placeholder={label.StandardSearchLable.EMAIL}
                            name="mobile"
                            value={filter.eMail}
                            onChange={(e) => onFieldChange('eMail', e.currentTarget.value)}
                            tabIndex={8}
                            maxLength={50} />
                        </FloatingLabel>
                      </div>

                    </div>

                    <div className='mb-0'>
                      <div className="input-group has-validation">
                        <span className="input-group-text remove-right-radius mb-3">
                          <Icon icon="mobile" className="text-muted fa-fw" />
                        </span>
                        <FloatLabel>
                            <InputText
                                id="Phone"
                                name="homePhone"
                                keyfilter="int"
                                value={filter.homePhone?.toString() || ''}
                                                      onChange={(e) => onFieldChange('homePhone', e.currentTarget.value.replace(/\D/g, '').slice(-10))}
                                                      onPaste={handlePaste}
                                tabIndex={9}
                                placeholder={label.StandardSearchLable.PHONE}
                                                      maxLength={10}>
                                                  </InputText>
                                                      <label htmlFor="Phone">{label.StandardSearchLable.PHONE}</label>
                                                  </FloatLabel>
                      </div>

                    </div>
                  </Column>
                </Row>

                {isAdvancedSearchFilter && (
                  <div className='mt-2 mb-0' style={{ width: '49%' }}>
                    <InputGroup className="mb-0" style={{ flexWrap: 'nowrap' }}>
                      <InputGroup.Text style={{ flex: '0 0 auto', whiteSpace: 'nowrap' }}>Policy Effective Date</InputGroup.Text>
                      <DatePicker
                        dateFormatCalendar="LLLL yyyy"
                        id="policyEffectiveDate"
                        dropdownMode="scroll"
                        selected={filter.PolEffDate ? new Date(filter.PolEffDate as any) : null}
                        onChange={(date: Date | null) => onFieldChange('PolEffDate', date || null)}
                        className='form-control'
                        style={{ width: '80px', flex: '0 0 auto' }}
                      />
                      <InputGroup.Text style={{ flex: '0 0 auto', padding: '0.375rem 0.5rem' }}>
                        <i className="bi bi-calendar3"></i>
                      </InputGroup.Text>
                    </InputGroup>
                  </div>
                )}

                {isAdvancedSearchFilter && (
                  <div className='mt-4 mb-0 pt-1' style={{ width: '49%' }}>
                    <Select
                      key={filter.CompanyId || 'no-parent'}
                      id="writingCompany"
                      controlId="writingCompany"
                      label="Writing Company"
                      options={filteredWritingCompanies}
                      defaultSelected={filteredWritingCompanies.filter(option => option.value === filter.WritingCompanyId)}
                      onChange={(values) => onFieldChange('WritingCompanyId', (values[0] as string) || null)}
                      tabIndex={16}
                      className='mb-0'
                      placeholder="Select Writing Company"
                      multiple={false}
                      disabled={!filter.CompanyId}
                    />
                  </div>
                )}

              </Column>
              <Column md={4}>
              </Column>
            </Row>
          </Column>

          <Column lg={5} md={5}>
            <Row >
              <Column className='ps-3'>
                <Row>
                <Column lg={8} md={8}>
                <div className='d-flex justify-content-between align-items-center mb-3'>
                  <div className='left d-flex align-items-center'>
                    <h6 className='poppins-bold me-3 mb-0' style={{ lineHeight: '34px' }}>Property Search</h6>
                    <div className=''>
                      <Form.Check
                        id='SearchProperty'
                        inline
                        type="radio"
                        checked={filter.isPropertySearch}
                        onClick={manageCollapse}
                        onKeyDown={(e) => {
                          if (e.key == "Tab" && !e.shiftKey) {
                            searchMailingControlRef.current.focus();
                            e.preventDefault();
                          }
                        }}
                        ref={searchPropertyControlRef}
                        name="searchType"
                        tabIndex={10}
                        label={label.StandardSearchLable.SEARCH_PROPERTY}
                      />

                    </div>
                    <div className=''>
                      <Form.Check
                        id='SearchMailing'
                        inline
                        type="radio"
                        name="searchType"
                        ref={searchMailingControlRef}
                        tabIndex={11}
                        onKeyDown={(e) => {
                          if (e.key == "Tab" && e.shiftKey) {
                            searchPropertyControlRef.current.focus();
                            e.preventDefault();
                          }
                        }}
                        checked={filter.isPropertySearch === false}
                        // onChange={handleSearchTypeChange}
                        label={label.StandardSearchLable.SEARCH_MAILING}
                        onClick={manageMailCollapse}
                      />
                    </div>
                  </div>
                  
                  
                </div>
                </Column>
                <Column lg={4} md={4}>
                  <Select
                    id="country"
                    tabIndex={12}
                    controlId="country"
                    label={label.StandardSearchLable.COUNTRY}
                    defaultSelected={countries?.filter(({ value }) => value === (filter.countryId))}
                    options={countries}
                    onChange={
                      (values) => {
                        onFieldChange('countryId', values[0] as string)
                        onCountrySelection(values[0] as string)
                      }
                    }
                    placeholder="Select Country"
                    multiple={false}
                    disabled={filter.isPropertySearch}
                  />
                </Column>
                
                </Row>
                <Row>
                  {/* Street Address */}
                  <Column lg={8} md={8}>
                    <div className='mb-4'>
                      <FloatLabel>
                        <Form.Control
                          type="text"
                          id="address1"
                          name="address1"
                          onKeyDown={(e) => {
                            if (e.key == "Tab" && e.shiftKey) {
                              searchMailingControlRef.current.focus();
                              e.preventDefault();
                            }
                          }}
                          value={filter.address1}
                          onChange={(e) => onFieldChange('address1', e.target.value)}
                          placeholder={label.StandardSearchLable.STREET_ADDRESS}
                          tabIndex={13}
                          maxLength={100}
                        />
                        <label htmlFor="address1">{label.StandardSearchLable.STREET_ADDRESS}</label>
                      </FloatLabel>
                    </div>

                  </Column>

                  {/* Unit/Apt */}
                  <Column lg={4} md={4}>
                    <div className='mb-4'>
                      <FloatLabel>
                        <Form.Control
                          type="text"
                          id="address2"
                          name="address2"
                          value={filter.address2}
                          onChange={(e) => onFieldChange('address2', e.target.value)}
                          placeholder={label.StandardSearchLable.APRARTMENT}
                          tabIndex={14}
                          maxLength={100}
                        />
                        <label htmlFor="address2">{label.StandardSearchLable.APRARTMENT}</label>
                      </FloatLabel>
                    </div>

                  </Column>
                </Row>

                <Row>
                  {/* City */}
                  <Column lg={5} md={5}>
                    <FloatLabel>
                      <Form.Control
                        type="text"
                        id="city"
                        name="city"
                        value={filter.city}
                        onChange={(e) => onFieldChange('city', e.target.value)}
                        placeholder=" "
                        tabIndex={15}
                        maxLength={50}
                      />
                      <label htmlFor="city">{label.StandardSearchLable.CITY}</label>
                    </FloatLabel>
                  </Column>

                  {/* State */}
                  <Column lg={4} md={4}>
                    {
                      isStateAsDropdown ?
                        <Select
                          id="state"
                          controlId="state"
                          label={label.StandardSearchLable.STATE}
                          options={states}
                          defaultSelected={states.filter(option =>
                            option.value === filter.state
                          )}
                          onChange={(values) => onFieldChange('state', values[0] as string)}
                          tabIndex={16}
                          className='mb-3'
                          placeholder="Select State"
                          multiple={false}
                        />
                        :
                        <FloatingLabel
                          controlId="txtState"
                          label={<>
                            {label.StandardSearchLable.STATE}
                          </>}
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder=" "
                            name="txtState"
                            value={filter.state ?? ""}
                            onChange={(event) => onFieldChange('state', event.currentTarget.value)}
                            tabIndex={17}
                            maxLength={100}
                          />
                        </FloatingLabel>
                    }




                  </Column>

                  {/* ZIP */}
                  <Column lg={3} md={3}>
                    <FloatLabel>
                      <Form.Control
                        type="text"
                        id="zipCode"
                        name="zipCode"
                        value={filter.zipCode}
                        onChange={(e) => onFieldChange('zipCode', e.target.value)}
                        placeholder=" "
                        tabIndex={17}
                        maxLength={10}
                      />
                      <label htmlFor="zipCode">{label.StandardSearchLable.ZIP}</label>
                    </FloatLabel>
                  </Column>
                </Row>
              </Column>
            </Row>
          </Column>

        </Row>

        <Row>

          <Column>
            <div className='d-flex mb-2 mt-3'>
              <Button
                key="Clear"
                icon="bi bi-x-circle"
                onClick={onClearFilters}
                tabIndex={18}
                id="btnStandardSearchClear"
                label={label.StandardSearchLable.CLEAR}
                ref={clearButtonRef}

                onKeyDown={(e) => {
                  if (e.key == "Tab" && saveButtonRef.current.disabled && !e.shiftKey) {
                    firstControlRef.current.focus();
                    e.preventDefault();
                  }
                }}
                unstyled={true}
                outlined={true}
                className='me-2'
              />

              <Button
                key="Search"
                icon="bi bi-search"
                onClick={onSearch}
                onKeyDown={(e) => {
                  if (e.key == "Tab" && !e.shiftKey) {
                    firstControlRef.current.focus();
                    e.preventDefault();
                  }
                }}
                disabled={!isSearchingAllowed || loading}
                loading={loading}
                tabIndex={19}
                id="btnStandardSearch"
                ref={saveButtonRef}
                label={label.StandardSearchLable.SEARCH}
              />

            </div></Column>
        </Row>
      </Container>
    </ErrorBoundary>
  )

}

export default CustomerStandardFilterForm